module.exports = __webpack_public_path__ + "static/media/service_online_1.d67b1992.png";